import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaTiktok,
  FaCalendarAlt,
  FaDumbbell,
  FaBook,
  FaCut,
  FaLandmark,
  FaUser
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FiChevronRight, FiShare } from 'react-icons/fi';
import './SocialLinks.scss';

const SOCIAL_GROUPS = [
  {
    title: 'Belediye Hesapları',
    sectionColor: '#f5a332',
    sectionIcon: <FaLandmark />,
    links: [
      { name: 'Facebook', url: 'https://www.facebook.com/iskenderunbel', icon: <FaFacebook />, iconColor: '#1877F2' },
      { name: 'Instagram', url: 'https://www.instagram.com/iskenderunbel/', icon: <FaInstagram />, iconColor: '#E4405F' },
      { name: 'X', url: 'https://x.com/iskenderunbel', icon: <FaXTwitter />, iconColor: '#111111' },
      { name: 'YouTube', url: 'https://www.youtube.com/@iskenderunbel', icon: <FaYoutube />, iconColor: '#FF0000' },
      { name: 'İskenderun Kültür ve Sosyal İşler', url: 'https://www.instagram.com/iskenderunkulturu/', icon: <FaInstagram />, iconColor: '#E4405F' },
    ]
  },
  {
    title: 'Başkan Mehmet Dönmez',
    sectionColor: '#45c268',
    sectionIcon: <FaUser />,
    links: [
      { name: 'Başkan Instagram', url: 'https://www.instagram.com/mehmetdonmezisk/', icon: <FaInstagram />, iconColor: '#E4405F' },
      { name: 'Başkan YouTube', url: 'https://www.youtube.com/@mehmetdonmezbb', icon: <FaYoutube />, iconColor: '#FF0000' },
      { name: 'Başkan X', url: 'https://x.com/mehmetdonmezbb', icon: <FaXTwitter />, iconColor: '#111111' },
      { name: 'Başkan Facebook', url: 'https://www.facebook.com/mehmetdonmezofficial', icon: <FaFacebook />, iconColor: '#1877F2' },
      { name: 'Başkan TikTok', url: 'https://www.tiktok.com/@mehmetdonmezbb', icon: <FaTiktok />, iconColor: '#101010' }
    ]
  },
  {
    title: 'Randevu Sistemleri',
    sectionColor: '#6cc6ff',
    sectionIcon: <FaCalendarAlt />,
    links: [
      { name: 'Spor Tesisleri Randevu', url: '/hizmet-rehberi/spor-randevu', icon: <FaDumbbell />, iconColor: '#0f75bc' },
      { name: 'Kütüphane Randevu', url: '/hizmet-rehberi/kutuphane-randevu', icon: <FaBook />, iconColor: '#16a085' },
      { name: 'Kuaför Randevu', url: '/hizmet-rehberi/kuafor-randevu', icon: <FaCut />, iconColor: '#f68b1e' },
      { name: 'Nikah İşlemleri', url: '/nikah-islemleri', icon: <FaCalendarAlt />, iconColor: '#9b59b6' }
    ]
  },
  {
    title: 'İletişim',
    sectionColor: '#5ec9ff',
    sectionIcon: <FaPhone />,
    links: [
      { name: 'WhatsApp', url: 'https://wa.me/905305421939', icon: <FaWhatsapp />, iconColor: '#25D366' },
      { name: 'E-Posta', url: 'mailto:bilgi@iskenderun.bel.tr', icon: <FaEnvelope />, iconColor: '#f68b1e' },
      { name: 'Telefon', url: 'tel:+904441939', icon: <FaPhone />, iconColor: '#0f75bc' },
      { name: 'Adres', url: 'https://maps.google.com/?q=36.59110536442947,36.16909620258949', icon: <FaMapMarkerAlt />, iconColor: '#16a085' }
    ]
  }
];

const isExternalUrl = (url) => /^(https?:|mailto:|tel:)/i.test(url);

const SocialLinks = () => {
  useEffect(() => {
    document.body.classList.add('social-links-active');
    return () => {
      document.body.classList.remove('social-links-active');
    };
  }, []);

  const handleShare = async () => {
    const shareUrl = window.location.href;
    const shareData = {
      title: 'İskenderun Belediyesi Sosyal Medya',
      text: 'İskenderun Belediyesi sosyal medya sayfası',
      url: shareUrl
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        return;
      }
    } catch (error) {
      return;
    }

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${shareData.text} ${shareUrl}`)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Helmet>
        <title>Sosyal Medya Hesaplarımız | İskenderun Belediyesi</title>
        <meta
          name="description"
          content="İskenderun Belediyesi sosyal medya hesapları, iletişim ve randevu bağlantıları"
        />
      </Helmet>

      <div className="social-links-page">
        <main className="social-links-shell">
          <div className="linktree-card">
            <div className="top-actions">
              <button type="button" className="circle-action" aria-label="Paylaş" onClick={handleShare}>
                <FiShare />
              </button>
            </div>

            <header className="profile-block">
              <img src="/assets/images/logo.png" alt="İskenderun Belediyesi" className="profile-avatar" />
              <h1>İskenderun Belediyesi</h1>
              <p>Sosyal medya hesaplarımızı takip edin</p>
              <span className="profile-divider" aria-hidden="true" />
            </header>

            {SOCIAL_GROUPS.map((group) => (
              <section key={group.title} className="links-group" style={{ '--section-color': group.sectionColor }}>
                <h2>
                  <span className="group-line" aria-hidden="true" />
                  <span className="group-title-wrap">
                    <span className="group-icon" aria-hidden="true">{group.sectionIcon}</span>
                    <span>{group.title}</span>
                  </span>
                  <span className="group-line" aria-hidden="true" />
                </h2>

                <div className="links-stack">
                  {group.links.map((link) => {
                    const external = isExternalUrl(link.url);

                    return (
                      <a
                        key={link.name}
                        href={link.url}
                        className="linktree-button"
                        target={external ? '_blank' : undefined}
                        rel={external ? 'noopener noreferrer' : undefined}
                      >
                        <span className="link-left-accent" aria-hidden="true" style={{ '--accent-color': link.iconColor }} />
                        <span className="link-icon" aria-hidden="true" style={{ color: link.iconColor }}>
                          {link.icon}
                        </span>
                        <span className="link-label">{link.name}</span>
                        <span className="link-more" aria-hidden="true">
                          <FiChevronRight />
                        </span>
                      </a>
                    );
                  })}
                </div>
              </section>
            ))}
          </div>
        </main>
      </div>
    </>
  );
};

export default SocialLinks;
